export default class Countdown {
	static init(e) {
		const countdowns = e.detail.element.querySelectorAll('[data-countdown]');

		countdowns.forEach((countdown) => {
			new Countdown(countdown);
		});
	}

	constructor(element) {
		// Elements
		this.element = element;
		this.days = this.element.querySelector('[data-days]');
		this.hours = this.element.querySelector('[data-hours]');
		this.minutes = this.element.querySelector('[data-minutes]');
		this.seconds = this.element.querySelector('[data-seconds]');

		// Data
		this.date = this.element.dataset.countdown;
		this.targetDate = new Date(this.date).getTime();
		this.interval = null;

		this.startCountdown();
	}

	startCountdown() {
		this.updateCountdown();

		this.interval = setInterval(() => {
			this.updateCountdown();
		}, 1000);
	}

	updateCountdown() {
		const now = new Date().getTime();
		const distance = this.targetDate - now;

		if (distance < 0) {
			clearInterval(this.interval);
		}

		const days = Math.floor(distance / (1000 * 60 * 60 * 24));
		const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((distance % (1000 * 60)) / 1000);

		this.days.innerHTML = Math.max(0, days);
		this.hours.innerHTML = Math.max(0, hours);
		this.minutes.innerHTML = Math.max(0, minutes);
		this.seconds.innerHTML = Math.max(0, seconds);
	}
}
